<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-table-tennis`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46 21c0-10.493-8.507-19-19-19S8 10.507 8 21c0 3.058.723 5.948 2.007 8.508L3.1 36.414a2 2 0 000 2.829L8.756 44.9a2 2 0 002.829 0l6.906-6.907A18.922 18.922 0 0027 40c10.493 0 19-8.507 19-19zM7.343 37.828l4.882-4.881a19.12 19.12 0 002.83 2.829l-4.883 4.88-2.829-2.828zM12 21c0 8.284 6.716 15 15 15 .38 0 .756-.014 1.129-.042L12.042 19.871c-.028.373-.042.75-.042 1.129zm1.123-5.705C15.368 9.84 20.735 6 27 6c8.284 0 15 6.716 15 15 0 6.264-3.84 11.632-9.294 13.877L13.123 15.295z"/></svg>
</template>
<script>

export default {
  name: 'IconTableTennis',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
